import React from 'react';

import PropTypes from 'prop-types';

import A from 'wanderu-component-react-router-link';
import {
    PageSection,
    Typography,
} from 'wanderu-components';
import { localize } from 'wanderu-i18n';

import { FEATURED_ROUTES } from '../../../data/featuredRoutes';

import styles from './FeaturedRoutes.scss';

function FeaturedRoutes(props) {
    const {
        t,
        locale,
    } = props;

    return (
        <PageSection layoutClassName={styles.container}>
            <Typography
                className={styles.title}
                variant="h3"
            >
                {t('featured-routes')}
            </Typography>
            <div className={styles.routesGrid}>
                {FEATURED_ROUTES[locale].map((route) => {
                    const linkTitle = t('origin-to-destination', {
                        originName: route.departCity,
                        destinationName: route.arriveCity,
                    });

                    return (
                        <A
                            className={styles.route}
                            href={route.url}
                            key={route.url}
                            variant="subdued"
                        >
                            <img
                                alt={linkTitle}
                                className={styles.routeImage}
                                height="192"
                                loading="lazy"
                                src={route.imageUrl}
                                width="341"
                            />
                            <span className={styles.linkTitle}>
                                {linkTitle}
                            </span>
                        </A>
                    );
                })}
            </div>
        </PageSection>
    );
}

FeaturedRoutes.propTypes = {
    locale: PropTypes.string.isRequired,
};

export { FeaturedRoutes };
export default localize(FeaturedRoutes, ['t'], 'baseApp');
